import { toType } from '@/lib/utils'
import { getEmailInfo, testSend, getTriggerCondition, addEmail } from '@/services/edm'

export default {
  namespaced: true,
  state: {
    emailInfo: {},
    triggerCondition: {
      allConfig: {},
      config: null
    },
    tab1Error: false,
    tab2Error: false,
    result: {}
  },
  mutations: {
    GET_EMAIL_INFO (state, data = {}) {
      if (data.config) {
        data.config.auto = data.config.auto === 1
        data.config.contactid = data.config.contactid === 0 ? undefined : data.config.contactid
      }
      state.emailInfo = data
    },
    GET_TRIGGER_CONFIG (state, data = {}) {
      state.triggerCondition.allConfig = data.allConfig || {}

      let { config = [] } = data
      if (typeof config !== 'string') {
        for (let i in config) {
          if (!config[i]._id) {
            config[i]._id = Math.random() * Math.pow(10, 17)
          }
        }
      }
      state.triggerCondition.config = config || []
    },
    SET_TRIGGER_CONFIG (state, data) {
      data.config && Object.assign(state.triggerCondition, { config: data.config })
    },
    SET_EMAIL_INFO (state, data = {}) {
      let { triggervalue = [] } = data.config || {}
      if ('config' in data && 'triggervalue' in data.config && toType(triggervalue) === 'array' && triggervalue.length) {
        data.config.triggervalue = triggervalue.map(item => {
          let { fieldtype, fieldvalue } = item
          let value = fieldvalue
          if (fieldtype === 'datetime' && toType(fieldvalue) === 'object') {
            let { starttime = '', endtime = '' } = fieldvalue || {}
            starttime = fieldvalue.starttime.replace(/-/g, '/')
            endtime = fieldvalue.endtime.replace(/-/g, '/')

            value = ['', ''] // starttime endtime
            value[0] = starttime ? parseInt(new Date(starttime).getTime() / 1000) : starttime
            value[1] = endtime ? parseInt(new Date(endtime).getTime() / 1000) : endtime
          } else if (fieldtype === 'datetime' && toType(fieldvalue) === 'string') {
            fieldvalue = fieldvalue.replace(/-/g, '/')
            value = parseInt(new Date(fieldvalue).getTime() / 1000)
          }
          return {
            ...item,
            fieldvalue: value
          }
        })
      }
      'config' in data && Object.assign(state.emailInfo, { config: data.config })
      'status' in data && Object.assign(state.emailInfo, { status: data.status })
      'id' in data && Object.assign(state.emailInfo, { id: data.id })
      'name' in data && Object.assign(state.emailInfo, { name: data.name })
      'content' in data && Object.assign(state.emailInfo, { content: data.content })

      /* const { key, value } = data
      state.emailInfo = Object.assign(state.emailInfo, { [key]: value }) */
    },
    SET_ERROR (state, data) {
      state.tab1Error = data.tab1Error
      state.tab2Error = data.tab2Error
    }
  },
  actions: {
    async fetchEmailInfo ({ commit }, params) {
      let chain = await getEmailInfo()
      chain
        .params(params)
        .config({ tip: false, warn: false })
        .onSuccess(res => {
          commit('GET_EMAIL_INFO', res)
        }).fetch()
      return chain
    },
    async testSend ({ commit }, params) {
      let chain = await testSend()
      chain
        .params(params)
        // .config({ tip: false })
        .fetch()
      return chain
    },
    async fetchTriggerCondition ({ commit }, params) {
      let chain = await getTriggerCondition()
      chain
        .params(params)
        .onSuccess(res => {
          commit('GET_TRIGGER_CONFIG', res)
        })
        .fetch()
      return chain
    },
    async addEmail ({ commit }, params) {
      let chain = await addEmail()
      chain
        .params(params)
        .fetch()
      return chain
    }
  }
}
